/**
 * Stable CSS class names for E2E — Empty-state illustration + message.
 */
export const NRFC = {
    root: 'no-result-found',
    imageOuter: 'no-result-found__image-outer',
    imageList: 'no-result-found__image-list',
    image: 'no-result-found__image',
    messageWrap: 'no-result-found__message-wrap',
    title: 'no-result-found__title',
} as const;

export const nrfcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
